import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';

export const BYSAVE = new HttpContextToken(() => false);
export const BYTOKEN = new HttpContextToken(() => false);

export const AuthSalesforceInterceptor: HttpInterceptorFn = (req, next) => {
  let authReq: any;
  if (req.context.get(BYSAVE) === true) {
    const token: any = sessionStorage.getItem('token');
    if (token) {
      authReq = req.clone({
        headers: req.headers
          .set('Authorization', `Bearer ${sessionStorage.getItem('token')}`)
          .set('Content-Type', 'application/json'),
      });
    }
    return next(authReq);
  }
  if (req.context.get(BYTOKEN) === true) {
    authReq = req.clone({
      headers: req.headers
        .set('Authorization', '$2y$10$N.kDlb1aMMZv1DbnAgcOv.S4dORvHx1kla3eg9wE3OR90YeoCk0Pm')
        .set('Content-Type', 'application/json'),
    });
    return next(authReq);
  }
  return next(req);
};
